import { Chart } from '@components/chart';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/stats/')({
  component: StatsPage,
});

function StatsPage() {
  return (
    <>
      <Chart />
    </>
  );
}
